import React, { useState } from 'react';
import { formatPrice, LoadingGrid, TableList } from '../../../../../rbts/helpers';
import { useHistorialRecargas } from '../hooks';

const View: React.FC = () => {
  const [folio, setFolio] = useState<string>('');
  const [reloadInfo, setReloadInfo] = useState<number>(Math.random() * 40);
  const { list, loadingRequest } = useHistorialRecargas(reloadInfo, folio);

  const columns: any = [
    {
      id: 'folio',
      name: <div className="fw-bolder text-muted me-5">Folio</div>,
      selector: (row: any) => row.folio,
      sortable: false,
    },
    {
      id: 'recarga',
      name: <div className="fw-bolder text-muted me-5">Recarga</div>,
      selector: (row: any) =>
        formatPrice(row.recarga || 0, 'es-MX', 'MXN', 2, 2),
      sortable: false,
    },
    {
      id: 'dia_administrativo',
      name: <div className="fw-bolder text-muted me-5">Día Administrativo</div>,
      selector: (row: any) => row.dia_administrativo,
      sortable: true,
    },
    {
      id: 'tipo_recarga',
      name: <div className="fw-bolder text-muted me-5">Tipo de Recarga</div>,
      selector: (row: any) => row.tipo_recarga,
      sortable: false,
    },
  ];

  const changeFolio = (e: any) => {
    if (e) {
      const { value } = e.target;
      setFolio(value);
    } else {
      setFolio('');
    }
  };

  return (
    <div className="d-flex flex-column flex-xl-row">
      <div className="col-xl-12">
        <div className="card mb-6 mb-xl-9">
          <div className="card-header border-0 pt-5">
            <div className="d-flex align-items-center">
              <label className="form-label fw-bold mb-0 me-3">Folio</label>
              <input
                type="text"
                placeholder="Ingrese folio del ticketcash"
                value={folio}
                onChange={changeFolio}
                className="form-control w-300px"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setReloadInfo(Math.random() * 40);
                  }
                }}
              />
              <button
                onClick={() => setReloadInfo(Math.random() * 40)}
                className="btn btn-primary w-200px ms-5"
                disabled={loadingRequest}
              >
                Buscar
              </button>
            </div>
          </div>
          <div className="card-body">
            {loadingRequest ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={list} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { View };
